<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="额度">
                  <el-input style="width: 200px;" v-model="queryForm.money"></el-input>
              </el-form-item>
              <el-form-item label="价格">
                  <el-input style="width: 200px;" v-model="queryForm.money"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getLifeFuelCardTypeList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addLifeFuelCardType"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editLifeFuelCardType(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteLifeFuelCardType(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshLifeFuelCardTypeList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="lifeFuelCardTypeList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="money"
        label="额度"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="price"
        label="价格"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="coverPic"
        label="封面"
        width="180"
      >
          <template slot-scope="scop">
              <el-image
                  @click='updateSrcList(scop.row.coverPic)'
                  style="width: 30px; height: 30px"
                  :src="scop.row.coverPic"
                  :preview-src-list="srcList"
              > </el-image>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkLifeFuelCardType(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editLifeFuelCardType(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteLifeFuelCardType(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="lifeFuelCardTypeStates[lifeFuelCardTypeState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="lifeFuelCardType"
          ref="lifeFuelCardTypeForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="额度"
            prop="money"
          >
            <el-input
              size="small"
              style="width: 200px;"
              v-model="lifeFuelCardType.money"
              :disabled="lifeFuelCardTypeState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="价格"
            prop="price"
          >
            <el-input
              size="small"
              style="width: 200px;"
              v-model="lifeFuelCardType.price"
              :disabled="lifeFuelCardTypeState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="封面"
            prop="coverPic"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="lifeFuelCardType.coverPic"-->
<!--              :disabled="lifeFuelCardTypeState == 'check'"-->
<!--            ></el-input>-->
              <el-upload
                  action=""
                  :disabled="lifeFuelCardTypeState == 'check'"
                  class="avatar-uploader"
                  :show-file-list="false"
                  :http-request="uploadAvatar"
                  style="width: 200px"
              >
                  <img
                      v-if="lifeFuelCardType.coverPic"
                      :src="lifeFuelCardType.coverPic"
                      class="avatar"
                  />
                  <i
                      v-else
                      class="el-icon-plus avatar-uploader-icon"
                  ></i>
              </el-upload>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="lifeFuelCardTypeState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetLifeFuelCardTypeList();
                    this.getLifeFuelCardTypeList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetLifeFuelCardTypeList();
                    this.getLifeFuelCardTypeList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     money: '', //额度
                     price: '', //价格
                     coverPic: '', //封面
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                lifeFuelCardTypeState: 'add',
                lifeFuelCardTypeStates: {
                    add: '新建出行卡类型',
                    check: '查看出行卡类型',
                    edit: '修改出行卡类型'
                },

                multipleSelection: [],
                lifeFuelCardTypeList: [],
                lifeFuelCardType: {
                    id: '', //ID
                    money: '', //额度
                    price: '', //价格
                    coverPic: '', //封面
                },
                btnLoading: false,

                rules: {
                    money: [{ required: true, message: '额度不能为空', trigger: 'blur' }],
                    price: [{ required: true, message: '价格不能为空', trigger: 'blur' }],
                    coverPic: [{ required: true, message: '封面不能为空', trigger: 'blur' }],
                },

                srcList: [""]
            };
        },
        created() {
            this.getLifeFuelCardTypeList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            updateSrcList(src){
                this.srcList[0] = src
            },
            uploadAvatar(params) {
                console.log({ params });
                const file = params.file;
                let types = ['image/jpeg', 'image/png', 'image/jpg'];
                if (!types.includes(file.type)) {
                    this.$message({
                        message: '只能上传图片格式的文件，png.jpg或者jpeg',
                        type: 'error',
                        showClose: true,
                        duration: 2000
                    });
                }
                const formData = new FormData();
                formData.append('file', file);
                console.log({ formData });
                upload(`/mpp/image/upload`, formData).then((res) => {
                    console.log({ res });
                    if (res.success) {
                        this.lifeFuelCardType.coverPic = res.url;
                    }
                });
            },
            resetLifeFuelCardTypeList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.lifeFuelCardTypeList = [];
            },
            resetDialog() {
                this.lifeFuelCardTypeState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      money: '', //额度
                      price: '', //价格
                      coverPic: '', //封面
                };
                this.getLifeFuelCardTypeList();
            },
            closeDialog() {
                this.showDialog = false
                this.lifeFuelCardType = {
                      id: '', //ID
                      money: '', //额度
                      price: '', //价格
                      coverPic: '', //封面
                };
            },
            submitForm() {
                if (this.lifeFuelCardTypeState == 'add') {
                    this.$refs.lifeFuelCardTypeForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/life/fuelcardtype/add`,{ ...this.lifeFuelCardType }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetLifeFuelCardTypeList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.lifeFuelCardTypeState == 'edit') {
                    this.$refs.lifeFuelCardTypeForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/life/fuelcardtype/edit`,{ ...this.lifeFuelCardType }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetLifeFuelCardTypeList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addLifeFuelCardType() {
                this.showDialog = true;
                this.lifeFuelCardTypeState = 'add';
            },
            checkLifeFuelCardType(lifeFuelCardTypeId) {
                console.log(lifeFuelCardTypeId);
                this.currentLifeFuelCardTypeId = lifeFuelCardTypeId;

                this.getLifeFuelCardTypeById();
                this.showDialog = true;
                this.lifeFuelCardTypeState = 'check';
            },
            editLifeFuelCardType(lifeFuelCardTypeId) {
                console.log('lifeFuelCardType', lifeFuelCardTypeId);
                if (lifeFuelCardTypeId) {
                    this.currentLifeFuelCardTypeId = lifeFuelCardTypeId;
                    this.getLifeFuelCardTypeById();
                } else {
                    this.lifeFuelCardType = { ...this.lifeFuelCardType, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.lifeFuelCardTypeState = 'edit';
            },
            deleteLifeFuelCardType(lifeFuelCardTypeId) {
                let ids = '';
                if (lifeFuelCardTypeId) {
                    ids = lifeFuelCardTypeId;
                } else {
                    ids = this.multipleSelection.map((lifeFuelCardType) => lifeFuelCardType.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/life/fuelcardtype/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetLifeFuelCardTypeList();
                                this.getLifeFuelCardTypeList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshLifeFuelCardTypeList() {
                this.resetLifeFuelCardTypeList();
                this.getLifeFuelCardTypeList();
            },
            getLifeFuelCardTypeList(query = {}) {
                this.loading = true;
                get(`/life/fuelcardtype/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.lifeFuelCardTypeList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getLifeFuelCardTypeById() {
                get(`/life/fuelcardtype/get`,{ id: this.currentLifeFuelCardTypeId }).then((res) =>{
                    if(res.success){
                      this.lifeFuelCardType = { ...this.lifeFuelCardType, ...res.lifeFuelCardType };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportLifeFuelCardTypeList() {
                //this.btnLoading = true;
                exprotExcel(`/life/fuelcardtype/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/life/fuelcardtype/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/life/fuelcardtype/importData`,formData);
              this.refreshLifeFuelCardTypeList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getLifeFuelCardTypeList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getLifeFuelCardTypeList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    button {
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 200px;
    height: 200px;
}
.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}
.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 150px;
    height: 150px;
    line-height: 200px;
    text-align: center;
}
.avatar {
    width: 200px;
    height: 200px;
    display: block;
}
</style>